import { RSAA } from 'redux-api-middleware';
import { MANUALLY_CLICKED } from '../../components/Address/addressUtils/addressConstants';

export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const FETCH_ADDRESS_SUCCESS = 'FETCH_ADDRESS_SUCCESS';
export const FETCH_ADDRESS_FAILED = 'FETCH_ADDRESS_FAILED';
export const SELECT_ADDRESS = 'SELECT_ADDRESS';
export const SELECT_ADDRESS_SUCCESS = 'SELECT_ADDRESS_SUCCESS';
export const SELECT_ADDRESS_FAIL = 'SELECT_ADDRESS_FAIL';
export const ON_DATE_CHANGE = 'ON_DATE_CHANGE';

export const onAddManuallyClick = (type, data, currentIndex) => ({
  type: `${type}${MANUALLY_CLICKED}`,
  data,
  meta: {
    currentIndex: currentIndex,
    key: type
  }
});

export const onFindAddressClick = (postCode, key, currentIndex) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/ref/address/search/${postCode}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: `${key}${FETCH_ADDRESS}`,
        meta: {
          loading: true
        }
      },
      {
        type: `${key}${FETCH_ADDRESS_SUCCESS}`,
        meta: {
          loading: false,
          currentIndex: currentIndex
        }
      },
      {
        type: `${key}${FETCH_ADDRESS_FAILED}`,
        meta: {
          loading: false,
          currentIndex: currentIndex
        }
      }
    ]
  }
});

export const onSelectAddressClick = (address, type, currentIndex) => ({
  [RSAA]: {
    endpoint: `:api_paas_url/ref/address/${address}`,
    method: 'GET',
    headers: {
      'x-bpi-version': '1.0.0'
    },
    types: [
      {
        type: `${type}${SELECT_ADDRESS}`,
        meta: {
          loading: true
        }
      },
      {
        type: `${type}${SELECT_ADDRESS_SUCCESS}`,
        meta: {
          loading: false,
          currentIndex: currentIndex
        }
      },
      {
        type: `${type}${SELECT_ADDRESS_FAIL}`,
        meta: {
          loading: false
        }
      }
    ]
  }
});

export const onDateChange = (type, date, currentIndex) => ({
  type: `${type}${ON_DATE_CHANGE}`,
  data: createActionData(type, date, currentIndex),
  meta: {
    currentIndex: currentIndex
  }
});

const createActionData = (type, data, currentIndex) => ({
  date: data,
  type: type,
  currentIndex: currentIndex
});
